const points = [
  {
    icon: 'ri-server-line',
    title: '稳定纯净的播放服务',
    desc: '多线路智能切换，播放稳定不卡顿，界面干净无多余干扰。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '更新快，追剧不等待',
    desc: '热门剧集同步更新，第一时间看到最新内容。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '贴合中文用户的体验',
    desc: '从片库分类到操作习惯，都按国内用户的使用方式设计。',
  },
  {
    icon: 'ri-download-cloud-line',
    title: '官方下载，放心安装',
    desc: '通过瓜子影视APP下载官网获取安装包，来源可靠更安心。',
  },
];

export default function GuaziAdvantages() {
  return (
    <section id="advantages" className="guazi-anchor w-full bg-background-100 pt-20 md:pt-28 pb-16 md:pb-24 px-4 md:px-6">
      <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
        {/* 吉祥物 + 气泡 */}
        <div className="w-full lg:w-[44%] relative flex justify-center pt-2 md:pt-4">
          <div className="absolute top-0 left-0 md:left-2 z-20 w-[210px] md:w-[230px] px-4 py-3 bg-background-50 border border-background-200 rounded-lg">
            <p className="text-xs md:text-sm text-foreground-700 leading-6">
              用瓜子影视看好剧，每天都有小惊喜！
            </p>
          </div>
          <img
            src="/images/guazi-mascot-2.png"
            alt="瓜子影视吉祥物形象"
            title="瓜子影视APP下载官网"
            className="relative z-10 mt-14 md:mt-20 w-[240px] md:w-[360px] guazi-float"
          />
        </div>

        {/* 优势列表 */}
        <div className="w-full lg:w-[56%]">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs md:text-sm font-bold">
            <i className="ri-award-line text-base" />
            为什么选择瓜子影视
          </span>
          <h2 className="mt-4 font-heading font-extrabold text-3xl md:text-4xl text-foreground-950">
            更懂你的影视播放软件
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-7">
            瓜子影视持续优化播放内核与片库体验，无论是在手机、平板还是电视上，都能获得一致的流畅观感。想安装体验，认准瓜子影视iOS官网最新下载安装与瓜子影视APP下载官网即可。
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {points.map((item, index) => (
              <div key={item.title} className="flex gap-3.5">
                <span className={`w-11 h-11 flex items-center justify-center rounded-lg shrink-0 ${index % 2 === 0 ? 'bg-primary-100 text-primary-700' : 'bg-accent-100 text-accent-700'}`}>
                  <i className={`${item.icon} text-xl`} />
                </span>
                <div>
                  <h3 className="font-heading font-bold text-base text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-sm text-foreground-600 leading-6">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}